"use client";

import { useTranslations } from "next-intl";

import { TOP_NAV_TOOLS } from "@/components/tools-hub/data";

import { NAV_PREVIEW_SUBNAV_GRADIENT } from "./nav-preview-blue-gradient";
import { NavPreviewSubnav } from "./nav-preview-subnav";
import { NavPreviewFrame } from "./preview-frame";

export function ResourcesToolsNavPreview() {
  const t = useTranslations("Nav.preview");

  const links = TOP_NAV_TOOLS.map((tool) => ({
    label: tool.title,
    href: tool.href,
  }));

  return (
    <NavPreviewFrame
      className={NAV_PREVIEW_SUBNAV_GRADIENT}
      contentClassName="items-start justify-start p-0 pr-3 pl-[48px] pt-[32px]"
    >
      <NavPreviewSubnav
        className="w-[334px]"
        columnGap="gap-6"
        linkGap="gap-4"
        label={t("tools.label")}
        columns={1}
        links={links}
        footerLink={{ label: "View all tools →", href: "/tools" }}
      />
    </NavPreviewFrame>
  );
}
